import { Theme } from '@mui/material/styles'

import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()((theme: Theme) => ({
  horizontalDivider: {
    height: theme.spacing(0.125),
    width: '100%',
    backgroundColor: theme.palette.dividerV2.main,
  },
  title: {
    fontFamily: theme.typography.fontFamily,
    color: theme.palette.shadows.light,
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '20px',
  },
  headingTitle: {
    fontFamily: theme.typography.fontFamily,
    color: theme.palette.poweredBy.main,
    fontSize: '18px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '27px',
    letterSpacing: '0.15px',
  },
  subTitle: {
    fontFamily: theme.typography.fontFamily,
    color: theme.palette.textField.dark,
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '24px',
    letterSpacing: '0.25px',
    marginTop: '4px',
    marginBottom: '4px',
  },
  wrapper: {
    display: 'flex',
  },
  fieldWrapper: {
    width: '49%',
    marginLeft: '16px',
    marginRight: '16px',
    marginBottom: '16px',
  },
  titleWrapper: { display: 'flex', justifyContent: 'space-between' },
  fieldContentWrapper: {
    width: '49%',
    marginLeft: '16px',
    marginRight: '16px',
    marginTop: '24px',
  },
  content: { display: 'flex', flexDirection: 'column', gap: '16px' },
  fieldWrapperTitle: { display: 'flex', gap: '16px' },
  width: {
    width: '100%',
  },
  iconPlacement: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: theme.spacing(1.5),
    marginTop: '-16px',
  },
  textFieldWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
  },
  textAreaHeight: { minHeight: theme.spacing(14.875) },
  longDescriptionHeight: { minHeight: theme.spacing(32.375) },
  titleHeight: {
    minHeight: theme.spacing(9.375),
  },
  chip: {
    display: 'flex',
    height: theme.spacing(4),
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: theme.spacing(1),
    backgroundColor: theme.palette.textBackground.main,
    padding: `${theme.spacing(0.75, 1, 0.75, 2)} !important`,
    gap: theme.spacing(1),
    border: 'none',
    '& .MuiChip-label': {
      textAlign: 'center',
      fontFamily: theme.typography.fontFamily,
      fontSize: '14px',
      fontStyle: 'normal',
      fontWeight: 500,
      lineHeight: '20px',
      letterSpacing: '0.1px',
      color: theme.palette.labraText.tertiary,
      padding: `${theme.spacing(0)} !important`,
    },
    '& .MuiChip-deleteIcon': {
      width: theme.spacing(2.25),
      height: theme.spacing(2.25),
      color: theme.palette.textField.main,
    },
    '& > span': {
      padding: theme.spacing(0),
    },
  },
  wrapperRoot: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(5),
  },
  sectionWrapper: { display: 'flex', gap: theme.spacing(2) },
  textWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontFamily: theme.typography.fontFamily,
    color: theme.palette.poweredBy.main,
    fontSize: '18px',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: '27px',
  },
  actionIcon: {
    width: 14,
    height: 14,
    color: theme.palette.select.light,
  },
}))
